const baseURL = process.env.REACT_APP_BASE_URL;
// const baseURL = "http://82.112.254.244:8014";

export const getImg = (id) => {
  if (!id) return null;
  return `${baseURL}/api/Storage/GetImageById?id=${id}`;
};
